import { render, staticRenderFns } from "./MasterGaji.vue?vue&type=template&id=5f2a93bb&scoped=true"
import script from "./MasterGaji.vue?vue&type=script&lang=js"
export * from "./MasterGaji.vue?vue&type=script&lang=js"
import style0 from "./MasterGaji.vue?vue&type=style&index=0&id=5f2a93bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2a93bb",
  null
  
)

export default component.exports